export default "__VITE_ASSET__CKrdURMN__"